module.exports = __webpack_public_path__ + "static/media/13.35c8d5f2.jpg";